var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"download":_vm.filename,"href":_vm.download()}},[_c('v-btn',{staticClass:"mx-2",attrs:{"fab":"","color":"primary"}},[_c('v-icon',[_vm._v(" mdi-download-outline ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }